export const LOCAL_STORAGE_ACCESS_TOKEN = 'accessToken'
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken'
